import axios from 'axios';
import store from '@/store';
import router from '@/routes';

//console.log('axios console', process.env, window.location.hostname);
// if (process.env == 'test') {
// 	axios.defaults.baseURL = process.env.VUE_APP_API_URL.replace('hair-', window.location.hostname + '-');
// 	console.log(axios.defaults.baseURL);
// } else {
// 	axios.defaults.baseURL = process.env.VUE_APP_API_URL;
// }

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.withCredentials = true;
axios.defaults.headers.common = {
	'Access-Control-Allow-Origin': '*',
	'Content-Type': 'application/json; charset = utf-8',
};
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

function setInterceptors(instance, show_loading_icon) {
	instance.interceptors.request.use(
		config => {
			//config.headers.Authorization = store.state.token;
			if (show_loading_icon) store.commit('setLoading', true);
			//config.headers.common['X-AUTH-TOKEN'] = store.state.token;
			return config;
		},
		error => {
			//console.log('Axios request error', error);
			if (show_loading_icon) store.commit('setLoading', false);
			Promise.reject(error.response);
		},
	);

	instance.interceptors.response.use(
		response => {
			if (show_loading_icon) store.commit('setLoading', false);
			return response;
			/*
			if (!response.headers.company_id) return response;

			console.log(response.headers.company_id, window.location.host.split('.')[0]);

			var url_host = window.location.host.split('.')[0];

			if (url_host == 'demo3') url_host = 'demo';

			if (url_host.startsWith('localhost') || response.headers.company_id == url_host) return response;

			window.location = '/login?sessionExpired=true&backUri=/'; */
		},
		error => {
			console.log(error);
			if (show_loading_icon) store.commit('setLoading', false);
			if (!error.response) {
				//console.log('Network Error');
				//this.$toast.success('Network Error');
				router.push({ name: 'error', params: { message: 'Network Error' } });
			} else {
				if (error.response.status === 403) {
					//if (store.getters['isLoggedIn']) alert('세션이 종료되어 다시 로그인합니다.');
					//store.commit('delToken');
					//router.push({ name: 'login', params: { sessionExpired: true } });
					//router.push({ name: 'login', params: { sessionExpired: true } });
					//router.push('/login');
					//alert(window.location.pathname);
					window.location = '/login?sessionExpired=true&backUri=' + window.location.pathname;
				} else {
					//console.log(error);
					router.push({ name: 'error', params: { message: error } });
				}
			}

			return Promise.reject(error);
		},
	);
	return instance;
}

const api = axios.create();
setInterceptors(api, true);

const session_api = axios.create();
setInterceptors(session_api, false);

export function apiHome() {
	return api.get('/api/home');
}

export function apiTest() {
	return api.get('/api/test');
}

// export function apiUps(param) {
// 	return api.post('/api/ups', param);
// }

export function apiSessionCheck() {
	return session_api.get('/api/global_session_check');
}

export function apiSystemMessage() {
	return session_api.get('/api/system_message');
}

export { api };
